import type { SVGProps } from 'react';

const SvgFileDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z" />
  </svg>
);
export default SvgFileDownload;
